module.exports = __webpack_public_path__ + "img/icon-draw.aefceb16.svg";